import { NavLink } from "react-router-dom";
import type { CurrentUser } from "@/types/user";

const NAV_ITEMS = [
  { to: "/", label: "ダッシュボード", roles: ["user", "manager", "admin"] },
  { to: "/calendar", label: "利用カレンダー", roles: ["user", "manager", "admin"] },
  { to: "/reservations/new", label: "利用申請", roles: ["user", "manager", "admin"] },
  { to: "/my-reservations", label: "自分の利用", roles: ["user", "manager", "admin"] },
  { to: "/approvals", label: "承認管理", roles: ["manager", "admin"] },
  { to: "/pcs", label: "PC管理", roles: ["admin"] },
  { to: "/users", label: "使用者管理", roles: ["admin"] },
  { to: "/settings", label: "設定", roles: ["user", "manager", "admin"] },
];

export function AppSidebar({ user }: { user: CurrentUser }) {
  return (
    <nav className="app-sidebar">
      <div style={{ fontWeight: 800, fontSize: 16, padding: "8px 12px 20px" }}>設備機材利用管理</div>
      <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
        {NAV_ITEMS.filter((item) => item.roles.includes(user.role)).map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.to === "/"}
            style={({ isActive }) => ({
              display: "block",
              padding: "10px 12px",
              borderRadius: 10,
              fontSize: 14,
              fontWeight: 600,
              textDecoration: "none",
              color: isActive ? "var(--color-primary)" : "var(--color-text)",
              background: isActive ? "var(--color-primary-soft)" : "transparent",
            })}
          >
            {item.label}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
